'use strict';

DoohApps
    .service('restApi', ['$http', '$location', 'DoohConfig', 'SessionHelper', 'User', '$route', 'Constants',
        function restApiService($http, $location, DoohConfig, SessionHelper, User, $route, Constants) {
            var _this = this;

            this.PutApiMethod = function (callbackMethod, methodName, jsonData) {
                UpdateToken(function () {
                    $http({ method: 'PUT', url: DoohConfig.RestApiBaseURL + methodName, headers: GetSecurityHeaders(), data: Object.assign({}, jsonData) })
                        .then(function (response) {
                            callbackMethod(createResponse(response));
                        })
                        .catch(function (response) {
                            handleError(response, callbackMethod);
                        });
                });
            };

            this.PostApiMethod = function (callbackMethod, methodName, jsonData) {
                UpdateToken(function () {
                    $http({ method: 'POST', url: DoohConfig.RestApiBaseURL + methodName, headers: GetSecurityHeaders(), data: Object.assign({}, jsonData) })
                        .then(function (response) {
                            callbackMethod(createResponse(response));
                        })
                        .catch(function (response) {
                            handleError(response, callbackMethod);
                        });
                });
            };

            this.GetApiMethod = function (callbackMethod, methodName, jsonData, ignore401) {
                UpdateToken(function () {
                    $http({ method: 'GET', cache: false, url: DoohConfig.RestApiBaseURL + methodName, headers: GetSecurityHeaders(), params: Object.assign({}, jsonData) })
                        .then(function (response) {
                            callbackMethod(createResponse(response));
                        })
                        .catch(function (response) {
                            handleError(response, callbackMethod, ignore401);
                        });
                });
            };

            this.GetApiMethodDownloadUrl = function (methodName, jsonData) {
                return DoohConfig.RestApiBaseURL + methodName + '?' + jQuery.param(GetSecurityParams(jsonData));
            };

            this.DeleteApiMethod = function (callbackMethod, methodName, jsonData) {
                UpdateToken(function () {
                    $http({ method: 'DELETE', url: DoohConfig.RestApiBaseURL + methodName, headers: GetSecurityHeaders(), params: Object.assign({}, jsonData) })
                        .then(function (response) {
                            callbackMethod(createResponse(response));
                        })
                        .catch(function (response) {
                            handleError(response, callbackMethod);
                        });
                });
            };

            this.LoginMethod = function (successCallback, failCallback, jsonData) {
                $http({ method: 'POST', url: DoohConfig.RestApiLoginURL, headers: GetSecurityHeaders(), data: Object.assign({}, jsonData) })
                    .then(function (response) {
                        successCallback(createResponse(response));
                    })
                    .catch(function (response) {
                        handleError(response, failCallback);
                    });
            }

            this.RefreshTokenMedhod = function (callbackMethod, jsonData) {
                $http({ method: 'POST', url: DoohConfig.RestApiLoginURL, headers: GetSecurityHeaders(), data: Object.assign({}, jsonData) })
                    .then(function (response) {
                        callbackMethod(createResponse(response));
                    })
                    .catch(function (response) {
                        handleError(response, callbackMethod);
                    });
            };

            this.CheckSessionStatusMethod = function (callback) {
                UpdateToken(function () {
                    $http({ method: 'GET', url: DoohConfig.CheckSessionURL, headers: GetSecurityHeaders() })
                        .then(function (response) {
                            callback(response.data);
                        });
                });
            }

            function createResponse(response) {
                var objResponse = {
                    Status: response.status,
                    Headers: response.headers,
                    Config: response.config,
                    Data: response.data
                };
                return objResponse;
            }

            function handleError(response, callbackMethod, ignore401) {
                var status = response.status == 0 ? 500 : response.status,
                    data = response.data;

                if (status == 401 && !ignore401) {
                    redirectToAppStore();
                    return;
                }

                var customReturnObjectRequired = (status == 404 && (data == '' || typeof (data) == undefined)) || status == 400 || data == null;
                var errorObject = customReturnObjectRequired
                    ? {
                        error_description: getStatusError(status, data),
                        status: status
                    }
                    : data;

                callbackMethod(errorObject);
            }

            function redirectToAppStore() {
                _this.CheckSessionStatusMethod(function (sessionIsActive) {
                    if (!sessionIsActive) {
                        User.clear();
                        sessionStorage['loginRequired'] = true;
                    }

                    if ($location.$$path != '/AppStore')
                        $location.path('/AppStore');
                    else
                        $route.reload();
                });
            }

            function getStatusError(status, data) {
                switch (status) {
                    case 404:
                        return Constants.errorMessages.HTTP_404;
                    case 401:
                        return Constants.errorMessages.HTTP_401;
                    case 400:
                        return getBadRequestErrorMessage(data);
                    default:
                        return Constants.errorMessages.HTTP_500;
                }
            }

            function getBadRequestErrorMessage(data) {
                if (data == null)
                    return Constants.errorMessages.HTTP_500;

                if (data.hasError)
                    return data.errors[0];

                return data.error_description || data.error || data.Message || (data.Data != undefined ? data.Data.error : null);
            }

            function GetSecurityParams(params) {
                params.access_token = localStorage['accessToken'];
                return params;
            }

            function GetSecurityHeaders(download) {
                var dt = new Date();
                var tz = -dt.getTimezoneOffset();
                var timezoneOffset = tz.toString();

                var companyId = User.company.id || 0;

                var headers = {
                    'Accept': 'application/json, text/plain, */*',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': ['GET', 'POST', 'OPTIONS', 'PUT', 'DELETE'],
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Access-Control-Allow-Credendtials': 'true',
                    'Content-Type': download ? 'application/octet-stream' : 'application/x-www-form-urlencoded; charset=UTF-8',
                    'ClientTimeZone': timezoneOffset,
                    'CompanyID': companyId,
                    'Language': User.language,
                };
                var accessToken = localStorage['accessToken'];
                if (accessToken && accessToken != 'null') {
                    headers.Authorization = 'Bearer ' + accessToken;
                    headers.UsedTimeZone = localStorage['TimeZoneIANA'] || moment.tz.guess();
                }
                return headers;
            }

            var lastConnection = new Date();
            function UpdateToken(callback) {
                if (typeof localStorage['tokenUpdateInProgress'] == 'undefined' && typeof localStorage['expires'] != 'undefined') {
                    var dateNow = new Date();
                    var dateExpires = new Date(localStorage['expires']);

                    //Refresh token if the last request was made more than 30 mins ago and it hasn't expired already
                    if (dateNow - lastConnection > 1800000 && dateExpires > dateNow) { //3(10800000) hours before access token expires
                        lastConnection = new Date();
                        localStorage['tokenUpdateInProgress'] = true;

                        _this.RefreshTokenMedhod(function (data) { refreshTokens(callback, data) }, {
                            grant_type: 'refresh_token',
                            refresh_token: localStorage['refreshToken'],
                        })
                    } else {
                        callback();
                    }
                } else {
                    waitForToken(callback, 0);
                }
            }

            function waitForToken(callback, time) {
                if (localStorage['tokenUpdateInProgress'] && time < 5000)
                    setTimeout(function () { waitForToken(callback, time + 10); }, 10);
                else if (localStorage['tokenUpdateInProgress'] && time >= 5000) {
                    clearUser();
                    callback();
                }                    
                else callback();
            }

            function refreshTokens(callback, data) {
                localStorage.removeItem('tokenUpdateInProgress');
                if (!((data.Data != undefined && data.Data.error != undefined)
                    || data.error != undefined || data.error_description != undefined)) {
                    SessionHelper.setAccessToken(data.Data.access_token, data.Data['.expires']);
                    SessionHelper.setRefreshToken(data.Data.refresh_token);
                } else
                    clearUser();
                callback();
            }

            function clearUser() {
                User.clear();
                SessionHelper.clearSessionLocalStorage();
            }
        }]);